export const getPaginationState = (paginationName, key) => state => state.pagination[paginationName][key]

export const isFetching = (paginationName, key) => state => {
  const paginationState = getPaginationState(paginationName, key)(state)
  return paginationState && paginationState.isFetching
}

export const canLoadMore = (paginationName, key) => state => {
  const paginationState = getPaginationState(paginationName, key)(state)
  return !paginationState || paginationState.pageCount === 0 || !!paginationState.nextPageUrl
}



/** WEBPACK FOOTER **
 ** ./src/selectors/paginate/paginate-selectors.js
 **/